import React, { Fragment, useEffect } from "react";
import DataTable from "../../../../Common/Components/DataTable";
import { useContactUs } from "../Hooks/index";
import Loading from "../../../../Common/Components/Loading";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import { Link } from "react-router-dom";
function List() {
  const { getData, data, loading, searchHandler, modal, setModal } =
    useContactUs();

  useEffect(() => {
    getData();
  }, []);

  return (
    <Fragment>
      <DataTable
        loading={loading.list}
        heads={[
          {
            title: "نام ",
            key: "fullname",
          },
          {
            title: "ایمیل",
            key: "email",
          },
          {
            title: "پیام",
            key: "message",
            type: "long",
          },
          {
            title: "زمان ثبت اطلاعات",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="برگزار کننده ای ثبت نشده است"
        list={data && data.data}
        data={data}
        search={searchHandler}
        links={[
          {
            function: selected => {
              setModal({
                data:
                  data &&
                  data.data &&
                  data.data.filter(item => item.id == selected[0])[0],
                visible: true,
              });
            },
            color: "primary",
            size: "col-2",
            html: "مشاهده",
          },
        ]}
      />
      <CustomModal
        show={modal.visible}
        handleClose={() => {
          setModal({ ...modal, visible: false });
        }}
        header={"متن پیام"}
      >
        <div>
          <p>{modal.data.message}</p>
        </div>
      </CustomModal>
    </Fragment>
  );
}

export default List;
